import { create } from 'zustand'

interface KioskSessionState {
  kioskCode: string | undefined
  setKioskCode: (code: string) => void
}

export const useKioskSession = create<KioskSessionState>(set => ({
  kioskCode: undefined,
  setKioskCode: code => set({ kioskCode: code }),
}))
